/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ats_Tip_Add_EducationInputs */

const en_ats_tip_add_education = /** @type {(inputs: Ats_Tip_Add_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add education history — many ATS require this section`)
};

const de_ats_tip_add_education = /** @type {(inputs: Ats_Tip_Add_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge deinen Bildungsweg hinzu — viele ATS erfordern diesen Bereich`)
};

const fr_ats_tip_add_education = /** @type {(inputs: Ats_Tip_Add_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez votre parcours scolaire — de nombreux ATS exigent cette section`)
};

const es_ats_tip_add_education = /** @type {(inputs: Ats_Tip_Add_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade historial educativo — muchos ATS requieren esta sección`)
};

const it_ats_tip_add_education = /** @type {(inputs: Ats_Tip_Add_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi il percorso formativo — molti ATS richiedono questa sezione`)
};

const nl_ats_tip_add_education = /** @type {(inputs: Ats_Tip_Add_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voeg opleidingsgeschiedenis toe — veel ATS vereisen deze sectie`)
};

const pl_ats_tip_add_education = /** @type {(inputs: Ats_Tip_Add_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj historię wykształcenia — wiele systemów ATS wymaga tej sekcji`)
};

const fi_ats_tip_add_education = /** @type {(inputs: Ats_Tip_Add_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisää koulutushistoria — monet ATS-järjestelmät vaativat tämän osion`)
};

const da_ats_tip_add_education = /** @type {(inputs: Ats_Tip_Add_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilføj uddannelseshistorik — mange ATS kræver denne sektion`)
};

const sv_ats_tip_add_education = /** @type {(inputs: Ats_Tip_Add_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lägg till utbildningshistorik — många ATS kräver denna sektion`)
};

/**
* | output |
* | --- |
* | "Add education history — many ATS require this section" |
*
* @param {Ats_Tip_Add_EducationInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ats_tip_add_education = /** @type {((inputs?: Ats_Tip_Add_EducationInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ats_Tip_Add_EducationInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ats_tip_add_education(inputs)
	if (locale === "fr") return fr_ats_tip_add_education(inputs)
	if (locale === "es") return es_ats_tip_add_education(inputs)
	if (locale === "it") return it_ats_tip_add_education(inputs)
	if (locale === "nl") return nl_ats_tip_add_education(inputs)
	if (locale === "pl") return pl_ats_tip_add_education(inputs)
	if (locale === "fi") return fi_ats_tip_add_education(inputs)
	if (locale === "da") return da_ats_tip_add_education(inputs)
	if (locale === "sv") return sv_ats_tip_add_education(inputs)
	return en_ats_tip_add_education(inputs)
});